import { useState } from "react";
import { toast } from "sonner";
import { PublicLayout } from "@/components/PublicLayout";
import { SectionHeading } from "@/components/shared";
import { Mail, MessageSquare, Clock, Send, MapPin } from "lucide-react";

export const COMPANY_ADDRESS = "Pathumthani Rd., Kubangluang, Khu Bang Luang, Lat Lum Kaeo District, Pathum Thani 12140, Thailand";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const submit = (e) => {
    e.preventDefault();
    toast.success("Message received. Our team will get back to you shortly.");
    setForm({ name: "", email: "", message: "" });
  };
  return (
    <PublicLayout>
      <section className="max-w-6xl mx-auto px-4 sm:px-6 pt-16 pb-20">
        <SectionHeading eyebrow="Contact" title="Get in touch"
          subtitle="Have a question about your account, deposits or the platform? Send us a message." />
        <div className="grid lg:grid-cols-2 gap-10">
          <div className="space-y-5">
            {[
              { icon: Mail, t: "Email", d: "support@aitechnology.com" },
              { icon: MapPin, t: "Address", d: COMPANY_ADDRESS, testId: "contact-address" },
              { icon: MessageSquare, t: "Support", d: "In-app notifications & ticketing via your dashboard" },
              { icon: Clock, t: "Hours", d: "Deposit & withdrawal reviews are processed daily" },
            ].map((c) => (
              <div key={c.t} className="glass rounded-2xl p-6 flex gap-4 items-start">
                <div className="w-11 h-11 rounded-xl bg-cyan-500/10 border border-cyan-500/20 flex items-center justify-center shrink-0">
                  <c.icon className="w-5 h-5 text-cyan-300" />
                </div>
                <div>
                  <h3 className="font-heading text-white">{c.t}</h3>
                  <p className="text-sm text-slate-400 mt-1" data-testid={c.testId}>{c.d}</p>
                </div>
              </div>
            ))}
          </div>
          <form onSubmit={submit} className="glass rounded-2xl p-7 space-y-4">
            <div>
              <label className="text-sm text-slate-300 mb-1.5 block">Name</label>
              <input data-testid="contact-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
                className="w-full bg-slate-900/60 border border-cyan-500/20 rounded-lg px-4 py-2.5 text-slate-100 focus:border-cyan-400 focus:outline-none" />
            </div>
            <div>
              <label className="text-sm text-slate-300 mb-1.5 block">Email</label>
              <input data-testid="contact-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="w-full bg-slate-900/60 border border-cyan-500/20 rounded-lg px-4 py-2.5 text-slate-100 focus:border-cyan-400 focus:outline-none" />
            </div>
            <div>
              <label className="text-sm text-slate-300 mb-1.5 block">Message</label>
              <textarea data-testid="contact-message" required rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })}
                className="w-full bg-slate-900/60 border border-cyan-500/20 rounded-lg px-4 py-2.5 text-slate-100 focus:border-cyan-400 focus:outline-none resize-none" />
            </div>
            <button type="submit" data-testid="contact-submit" className="btn-glow w-full inline-flex items-center justify-center gap-2 py-3 rounded-lg font-semibold text-slate-950">
              <Send className="w-4 h-4" /> Send Message
            </button>
          </form>
        </div>
      </section>
    </PublicLayout>
  );
}
